export default __webpack_public_path__ + "static/nobackground-70c0b3d9bf3af8e9bbfdcd78aa02fb4d.png";